import { MetricsConfigColumnDefinition } from '@agyletime/performance-utils';

export enum METRIC_STATUS {
    'Disabled', 'Enabled'
}

export interface RowData {
    metrics?: string;
    status: typeof METRIC_STATUS[number];
    type?: string;
    format?: string;
    permission?: unknown;
    metricDefinition: MetricsConfigColumnDefinition;
}